"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeviceType = exports.handleHeightResize = exports.bindResponsiveStyles = exports.getResponsiveStyles = exports.getFinalStyles = exports.getAbsoluteLoginUrl = void 0;
const constants_1 = require("./constants");
const interface_1 = require("./interface");
const getAbsoluteLoginUrl = (loginUrl) => {
    return loginUrl.startsWith('http')
        ? loginUrl
        : `${window.location.origin}${loginUrl}`;
};
exports.getAbsoluteLoginUrl = getAbsoluteLoginUrl;
const getFinalStyles = () => {
    const isMobile = window.matchMedia(constants_1.MOBILE_MEDIA_QUERY).matches;
    return isMobile ? { bottom: '0' } : { right: '50%' };
};
exports.getFinalStyles = getFinalStyles;
const getResponsiveStyles = (component) => {
    const isMobile = window.matchMedia(constants_1.MOBILE_MEDIA_QUERY).matches;
    return isMobile
        ? constants_1.RESPONSIVE_STYLES.MOBILE[component]
        : constants_1.RESPONSIVE_STYLES.DESKTOP[component];
};
exports.getResponsiveStyles = getResponsiveStyles;
const bindResponsiveStyles = ({ component, componentName, finalStylesApplied = false, }) => {
    if (finalStylesApplied) {
        requestAnimationFrame(() => {
            Object.assign(component.style, (0, exports.getFinalStyles)());
        });
    }
    Object.assign(component.style, (0, exports.getResponsiveStyles)(componentName));
    window.addEventListener('resize', () => {
        Object.assign(component.style, (0, exports.getResponsiveStyles)(componentName));
        if (finalStylesApplied) {
            requestAnimationFrame(() => {
                Object.assign(component.style, (0, exports.getFinalStyles)());
            });
        }
    });
};
exports.bindResponsiveStyles = bindResponsiveStyles;
const handleHeightResize = ({ type, height }) => {
    if (type === interface_1.IFRAME_MESSAGE.HEIGHT_RESIZE && height) {
        const iframeWrapper = document.getElementById(constants_1.STYLES.wrapper.id);
        if (iframeWrapper) {
            iframeWrapper.style.height = `${height}px`;
        }
    }
};
exports.handleHeightResize = handleHeightResize;
const getDeviceType = () => {
    return document.body.clientWidth <= 768
        ? constants_1.DEVICE_TYPE.MOBILE
        : constants_1.DEVICE_TYPE.DESKTOP;
};
exports.getDeviceType = getDeviceType;
//# sourceMappingURL=utils.js.map